export const API_BASE_URL = 'https://apis.palkin.rs';
export const authToken = 'V73K+DO06RYLXzyWF53ZPzIYM7jONhfjQjGsFbJm3zMU6/yLgNIKvn1jjQ+CwIoN';
